import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mantine/core";
export const AutoHeightContainer = ({ children, style }) => {
    return (_jsx(Stack, { flex: 1, style: { width: "100%", minHeight: 0, ...style }, children: children }));
};
